const clearLocalStorage = () => {
    const i18nextLngInLastSession = localStorage.getItem("i18nextLng");
    localStorage.clear();
    localStorage.setItem("i18nextLng", i18nextLngInLastSession);
};

export default clearLocalStorage;
